import PropTypes from "prop-types";

const Button = (props) => {
  const handleClick = (e) => {
    if (e.preventDefault) e.preventDefault();
    if (props.handleClick) props.handleClick();
  };
  return (
    <button
      className={`focus:outline-none focus:ring-2 ${props.className}`}
      onClick={handleClick}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
};
export default Button;
